var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"party"},[_c('router-link',{attrs:{"to":{ name: 'party', params: { partyId: _vm.partyId } }}},[_c('ProgressBar',{attrs:{"showPartyInfo":true,"partyId":_vm.partyId,"value":_vm.affinity,"total":_vm.totalStatements}},[_vm._v(" "+_vm._s(_vm.affinity)+" / "+_vm._s(_vm.totalStatements)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }